import {numberOfCardsPerRow} from "../ConstantsAndHelper";

function Datenschutz() {
    let dflexStyle = "";
    if (numberOfCardsPerRow() < 2) {
        dflexStyle = " align-items-center flex-column";
    }
    return (
        <div className={"d-flex justify-content-center" + dflexStyle}>

            <div className="card" style={{width: '19rem', margin: '1rem'}}>
                <div className="card-body">
                    <h1 className="card-title">
                        <i className="bi bi-database"></i>
                    </h1>
                    <h3 className="card-title" style={{marginBottom: '1rem'}}>
                        Hinweis zum Datenschutz
                    </h3>
                    <p>Es werden keine personenbezogenen Daten gespeichert und verarbeitet.
                        Es erfolgt auch keine Übertragung personenbezogener Daten an Dritte.
                        Nutzungsdaten werden anonymisiert gespeichert.</p>
                </div>
            </div>

            <div className="card" style={{width: '19rem', margin: '1rem'}}>
                <div className="card-body">
                    <h1 className="card-title">
                        <i className="bi bi-cookie"></i>
                    </h1>
                    <h3 className="card-title" style={{marginBottom: '1rem'}}>
                        Hinweis zu Cookies
                    </h3>
                    <p>Diese Seite nutzt ausschließlich technisch notwendige Cookies.</p>
                </div>
            </div>
        </div>
    );
}

export default Datenschutz;